import { CITY_SLUG } from 'dpl/constants/query_params';

export function puppiesResourceDefinition(
  breedId,
  itemsPerPage,
  currentPage,
  filters
) {
  return {
    url: `/api/breeds/${breedId}/puppies.json`,
    params: {
      per_page: itemsPerPage,
      page: currentPage,
      ...filters
    },
    defaultValue: {
      meta: {
        available_delivery_methods: []
      },
      data: []
    }
  };
}

export function puppyAndBreederCountsResourceDefinition(breedId, filters) {
  return {
    url: `/api/breeds/${breedId}/puppy_and_breeder_counts.json`,
    params: {
      ...filters
    }
  };
}

// Also the eligibility check: an ineligible search comes back with no rows.
// `results_type` is not sent - the module is always the puppy carousel.
// `placeholder_color` matches the white card, not the sand band behind it.
export function similarBreedResultsResourceDefinition(breedId, filters) {
  return {
    url: `/api/breeds/${breedId}/similar_breed_results.json`,
    params: { ...filters, placeholder_color: 'white' },
    defaultValue: {
      meta: {},
      data: {}
    }
  };
}

// Eligibility and arm for the "Similar breeds" toggle. Serves no rows.
// `page` is deliberately not accepted or sent, so react-query holds one
// response across pagination and both result tabs rather than refetching and
// flickering the filter out from under the visitor.
export function similarBreedFilterResourceDefinition(breedId, filters) {
  return {
    url: `/api/breeds/${breedId}/similar_breed_filter.json`,
    params: { ...filters },
    defaultValue: {
      meta: { variant: 'control', eligible: false }
    }
  };
}

// The "See all" overlay's results: the same selection the module renders, a
// page at a time and with richer cards. `results_type` is sent here, unlike in
// the module's definition, because this surface has tabs.
export function similarBreedSeeAllResultsResourceDefinition(breedId, filters) {
  return {
    url: `/api/breeds/${breedId}/similar_breed_results/see_all.json`,
    params: { ...filters, placeholder_color: 'white' },
    defaultValue: {
      meta: {},
      data: {}
    }
  };
}

export function nearbyBreederProfilesResourceDefinition(breedId, filters) {
  return {
    url: `/api/breeds/${breedId}/nearby_breeder_profiles.json`,
    params: filters
  };
}

export function nearbyOwnerStoriesResourceDefinition(breedId, citySlug) {
  return {
    url: `/api/breeds/${breedId}/nearby_owner_stories.json`,
    params: { [CITY_SLUG]: citySlug },
    defaultValue: { data: [] }
  };
}

export function newsletterSignupMutationDefinition() {
  return {
    url: '/api/email_list_registrations.json',
    method: 'POST'
  };
}
